import { ajaxCart } from './ajax-cart'

export const addToCart = ($form, widget) => {
  $.ajax({
    url: '/cart/add.js',
    method: 'POST',
    dataType: 'json',
    data: $form.serialize(),
    success: function (result) {
      ajaxCart(widget)
    },
    error: function (error) {
      alert(error.responseJSON.description)
    }
  })
}
